export type GetAuditAsset = {
  url: string;
  resizeUrl: string;
};
